module.exports = __webpack_public_path__ + "cca8bfc9c6088b7dd71f25230a54407e.svg";